var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div ng-init=\"moduloCtrl.getFormModuli(dataItem); dataItemParent=dataItem\">\n<div class=\"grigliapermessimoduli\" ng-hide=\"moduloCtrl.inModificaModuli\" kendo-grid=\"moduloCtrl.griglieModuli[dataItem.uid]\" k-options=\"moduloCtrl.moduliCfg[dataItem.uid]\" k-on-data-bound=\"moduloCtrl.ridimensiona()\"></div>\n<div ng-show=\"moduloCtrl.inModificaModuli\">\nModifiche in corso attendi\n</div>\n</div>";
var id1="tabmoduli.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;